module.exports = __webpack_public_path__ + "img/2.191bc95f.png";